module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-5.90cd7be4.svg";